import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function getApropoUsersQuery(projectId) {
  return await fetchData(`api/apropo/users/${projectId}`, APIMethod.GET, {
    baseURL: ACCESS_DOMAINS.btApi,
  });
}
